import { Button } from "@/atoms-react/button/Button.react";
import { Base } from "@/atoms-react/text/Text.react";
import { MiniAnimatedShield } from "@/components/animations/minishield/index.react";
import { CompanyResponse } from "@/features/company/types";
import { FullCountry } from "@/features/user/types";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

type AddCompanyRepresentativeFormPrps = {
  onValidate: (data?: CompanyResponse) => void;
  companyAdded?: CompanyResponse;
  countries: FullCountry[];
  loaderRefresh: boolean;
};
export const FinalStepCompanAdd = ({
  onValidate,
  companyAdded,
  countries,
  loaderRefresh
}: AddCompanyRepresentativeFormPrps) => {
  const { t } = useTranslation(["pass"]);
  const getCountry = () =>
    countries.find((country) => country.id.toString() === companyAdded?.home_address?.Country);
  return (
    <div>
      <div className="mt-8 flex flex-col-reverse justify-between border-2 border-slate-50 p-4 md:flex-row dark:border-slate-700">
        <div className="flex flex-col">
          <div>
            <Base className="mb-5 font-semibold text-base text-black">
              {companyAdded?.legal_name}
            </Base>
          </div>
          <div className="flex flex-col">
            <Base>{companyAdded?.home_address?.Address1}</Base>
            <div className="flex flex-row">
              <Base className="text-sm">{`${companyAdded?.home_address?.City}  ${companyAdded?.home_address?.ZipCode}`}</Base>
            </div>
            <Base className="text-sm">{getCountry()?.name}</Base>
          </div>
        </div>
        <div className="mb-3 flex flex-row justify-end md:mb-0 md:w-[500px]">
          <div
            className={twMerge(
              `flex w-full w-full flex-start justify-center rounded-sm bg-bottom bg-cover md:w-1/5 lg:px-5`,
              "h-[100px] bg-[url('/images/olkypass/declarative_kyc_bg.png')]"
            )}
          >
            <div className={"flex flex-col justify-center"}>
              {
                <MiniAnimatedShield
                  style="bottom-14 left-4 w-5 h-3"
                  colors="#D11E1F"
                  percentage={45}
                />
              }
            </div>
          </div>
        </div>
      </div>
      <div className="mt-8 flex w-full flex-row justify-center">
        <Button
          size="md"
          loading={loaderRefresh}
          onClick={() => {
            onValidate(companyAdded);
          }}
          className="w-1/3 rounded-sm bg-primary"
        >
          {t("business.button.representative_button")}
        </Button>
      </div>
    </div>
  );
};
